<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { ThemeProvider, BuildInfo } from '@design-system/vue-ui';
import AppShell from './components/AppShell.vue';
import { seedDesignSystemTheme } from './composables/useTheme';
import { getBuildInfo } from './buildInfo';

// Must run before `ThemeProvider` mounts below (016.2 AC3) — it reads
// `design-system-theme` on setup to resolve its initial mode, so a
// returning user's persisted `cwc-theme` has to be mirrored into that key
// first, or `ThemeProvider` would resolve to the system default instead.
seedDesignSystemTheme();

const navItems = [
  { to: '#/', label: 'Home' },
  { to: '#/configure', label: 'Configure' },
  { to: '#/chat', label: 'Chat' },
  { to: '#/tools', label: 'Tools' },
  { to: '#/health', label: 'Health' },
  { to: '#/errors', label: 'Errors' },
];

const route = useRoute();
const isChromeless = computed(() => route.meta.chromeless === true);

const buildInfo = getBuildInfo();
</script>

<template>
  <ThemeProvider>
    <AppShell :nav-items="navItems" :chromeless="isChromeless">
      <RouterView />
    </AppShell>
    <BuildInfo :commit-sha="buildInfo.commitSha" :build-time="buildInfo.buildTime" />
  </ThemeProvider>
</template>
